<template>
  <div class="login-body">
    <div class="container login-NC-Pro">
      <div class="row box-centro">
        <div class="col-lg-12 ml-auto mr-auto">
          <slot />
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
	name: 'Default'
}
</script>



// WEBPACK FOOTER //
// src/components/Default.vue